import { mapState } from 'vuex'

const SCRIPT_LOAD_STATES = {
    NOT_LOADED: 'Not loaded',
    LOADING: 'loading',
    LOADED: 'loaded'
}

export default {
    data: function() {
        return {
            isAnalyticsConfigured: true,
            queue: [],
            scriptUrl: window.location.host === process.env.VUE_APP_HOST
                ? process.env.VUE_APP_TRACKING_ADOBE_SRC_PROD
                : process.env.VUE_APP_TRACKING_ADOBE_SRC_DEV,
            pageCountry: 'ch',
            applicationName: 'nachfolge',
            analyticsFormName: 'nachfolge'
        }
    },
    mounted() {
        this.initializeCookieStatus()

        window.adobeDataLayer = window.adobeDataLayer || []
        window.adobeDataLayer.push(function(dl) {
            dl.getState()
        })
        this.scriptLoadState = this.isScriptLoaded(this.scriptUrl)
            ? SCRIPT_LOAD_STATES.LOADED
            : SCRIPT_LOAD_STATES.NOT_LOADED
    },
    computed: {
        ...mapState('app', [
            'language'
        ])
    },
    methods: {
        _setCookie(name, value, exdays) {
            var exdate = new Date()
            exdate.setDate(exdate.getDate() + exdays)
            var cookievalue = escape(value) + ((exdays == null) ? '' : '; expires=' + exdate.toUTCString())
            document.cookie = name + '=' + cookievalue
        },
        initializeCookieStatus() {
            const c = 'ubs_cookie_settings_' + process.env.VUE_APP_UBS_COOKIE_VERSION
            /* eslint-disable */
            window.cookie_management_getPrivacySettings = function() {
                var a = ("; " + document.cookie).split("; " + c + "=");
                a = 2 <= a.length ? a.pop().split(";").shift() : void 0;
                var d = window.cookie_management_privacyPolicy,
                    b = {
                        thirdParty: !1,
                        tracking: !1,
                        userPreference: !1,
                        functional: !0
                    };
                a ? (b.thirdParty = -1 !== a.indexOf(4), b.tracking = -1 !== a.indexOf(3), b.userPreference = -1 !== a.indexOf(2)) : "STRICT" !== d && (b.thirdParty = !0, b.tracking = !0, b.userPreference = !0);
                return b
            }
            /* eslint-enable */
            this._setCookie('sat_track', window.cookie_management_getPrivacySettings().tracking, 1)
        },
        isScriptLoaded(src) {
            return document.querySelector('script[src="' + src + '"]')
        },
        loadScript() {
            if (!window.cookie_management_getPrivacySettings().tracking ||
                this.scriptLoadState !== SCRIPT_LOAD_STATES.NOT_LOADED) {
                return
            }

            if (!this.scriptUrl) {
                console.log('Analytics: No script configured.')
                return
            }

            this.scriptLoadState = SCRIPT_LOAD_STATES.LOADING
            const script = document.createElement('script')

            script.onload = () => {
                this.scriptLoadState = SCRIPT_LOAD_STATES.LOADED
                this.queue.forEach(trackEvent => trackEvent())
                this.queue = []
            }
            script.src = this.scriptUrl
            window.document.body.appendChild(script)
        },
        trackPageView() {
            window.adobeDataLayer.push({
                event: 'pageView',
                page: {
                    siteName: this.applicationName,
                    name: 'Homepage',
                    URL: window.location.href,
                    path: window.location.pathname,
                    pageCountry: this.pageCountry,
                    language: this.language
                },
                user: {
                    userAgent: navigator.userAgent,
                    internal: 'internal'
                }
            })
            this.track('Site Page View')
        },
        trackCTAClick(option) {
            window.adobeDataLayer.push({
                event: 'ctaClick',
                component: {
                    name: option.CTAName,
                    link: option.CTALink
                }
            })
            this.track('Site Page View')
        },
        trackFormStart() {
            window.adobeDataLayer.push({
                event: 'formStart',
                form: {
                    name: this.analyticsFormName
                }
            })
            this.track('Site Form Start')
        },
        getStepName(index, stepName) {
            return index + ' | form step | ' + stepName
        },
        trackFormStep(step) {
            window.adobeDataLayer.push({
                event: 'formStep',
                form: {
                    name: this.analyticsFormName,
                    stepName: this.getStepName(step.index, step.name),
                    answers: step.answer
                }
            })
            this.track('Site Form Step View')
        },
        trackFormSuccess(stepName) {
            window.adobeDataLayer.push({
                event: 'formSuccess',
                form: {
                    name: this.analyticsFormName,
                    stepName: stepName
                }
            })
            this.track('Site Form Completed')
        },
        trackFormError(step, errorMessage) {
            window.adobeDataLayer.push = {
                event: 'formError',
                form: {
                    name: this.analyticsFormName,
                    stepName: step.name,
                    errorMessage: errorMessage
                }
            }
            this.track('Site Form Error')
        },
        track(event, data = null) {
            if (this.isAnalyticsConfigured) {
                if (this.scriptLoadState === SCRIPT_LOAD_STATES.LOADED) {
                    window._satellite.track(event, data)
                } else {
                    if (this.scriptLoadState === SCRIPT_LOAD_STATES.NOT_LOADED) {
                        this.loadScript()
                    }
                    this.queue.push(() => window._satellite.track(event, data))
                }
            }
        }
    }
}
